import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import {
  ReliabilityDetails,
  ReliabilityDesktop,
  EscrowDescription,
  NewbuildingReliabilityContext,
} from '@cian/frontend-newbuilding-reliability-widget';
import { useSelector } from 'react-redux';
import { trackHousesWithEscrowLinkClick, trackReliableBlockShow } from './tracking';
import { EscrowHouses } from '../../components/EscrowHouses';
import { Layout } from '../../components/Layout';
import { DOM_RF_LINK } from '../../constants/externalLinks';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { getEscrowHouses } from '../../selectors/newbuilding/getEscrowHouses';
import { reliabilitySelector } from '../../selectors/reliability';
import { useApplicationContext } from '../../utils/withApplicationContext';

export const ReliabilityV2Container = () => {
  const newbuildingId = useSelector(getNewbuildingId);
  const houses = useSelector(getEscrowHouses);
  const reliability = useSelector(reliabilitySelector);
  const [isDetaisOpen, setIsDetailsOpen] = React.useState<boolean>(false);
  const [isEscrowOpen, setEscrowOpen] = React.useState<boolean>(false);

  const closeDetails = React.useCallback(() => setIsDetailsOpen(false), [setIsDetailsOpen]);
  const openDetails = React.useCallback(() => setIsDetailsOpen(true), [setIsDetailsOpen]);

  const closeEscrow = React.useCallback(() => setEscrowOpen(false), [setEscrowOpen]);
  const openEscrow = React.useCallback(() => setEscrowOpen(true), [setEscrowOpen]);

  const { httpApi, logger } = useApplicationContext();

  const contextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  const onReliableBlockShow = React.useCallback(() => {
    trackReliableBlockShow();
  }, []);

  if (!reliability) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={onReliableBlockShow} triggerOnce>
      <Layout dataTestId="reliablev2">
        <div id="reliable">
          <ReliabilityDesktop
            title={reliability.checkStatus.title}
            // oxlint-disable-next-line typescript/no-explicit-any
            status={reliability.checkStatus.status as any}
            date={reliability.checkStatus.date}
            // oxlint-disable-next-line typescript/no-explicit-any
            details={reliability.details as any}
            domrfLink={DOM_RF_LINK}
            onEscrowButtonClick={openEscrow}
            onDetailsButtonClick={openDetails}
            actions={reliability.actions}
          />
          <NewbuildingReliabilityContext.Provider value={contextValue}>
            <ReliabilityDetails
              onClose={closeDetails}
              open={isDetaisOpen}
              onEscrowIconClick={openEscrow}
              newbuildingId={newbuildingId}
            />
          </NewbuildingReliabilityContext.Provider>

          <EscrowDescription
            onClose={closeEscrow}
            isOpen={isEscrowOpen}
            houses={
              <EscrowHouses onClick={trackHousesWithEscrowLinkClick} houses={houses} newbuildingId={newbuildingId} />
            }
          />
        </div>
      </Layout>
    </ActionAfterViewObserver>
  );
};
